// extracted by mini-css-extract-plugin
export default {"btn":"ReservationCard_btn__B8F24","borderLightBtn":"ReservationCard_borderLightBtn__e1FzW"};